<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "circle-line-up" });
export let css = "";
export let isScaling = true;
</script>

<svg xmlns = 'http://www.w3.org/2000/svg'
    fill = 'none'
    viewBox = '0 0 18 18'
    on:mouseenter
    on:mouseleave
    on:keypress
    on:click
    class = { `s8-icon ${ css }` }
    stroke = '#272711'
>
    <g clip-path = 'url(#clip0_1990_23453)'>
        <!-- eslint-disable max-len -->
            <path
                d = 'M13.5 7.5L10.9243 10.0757C10.7758 10.2242 10.7015 10.2985 10.6159 10.3263C10.5406 10.3508 10.4594 10.3508 10.3841 10.3263C10.2985 10.2985 10.2242 10.2242 10.0757 10.0757L7.92426 7.92426C7.77576 7.77576 7.7015 7.7015 7.61588 7.67368C7.54057 7.64921 7.45943 7.64921 7.38412 7.67368C7.2985 7.7015 7.22424 7.77576 7.07574 7.92426L4.5 10.5M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z'
                stroke-width = '1.5'
                stroke-linecap = 'round'
                stroke-linejoin = 'round'
                vector-effect = { isScaling ? 'none' : 'non-scaling-stroke' }>
            </path>
        <!-- eslint-enable -->
    </g>
    <defs>
        <clipPath id = 'clip0_1990_23453'>
            <rect width = '18' height = '18' fill = 'white'/>
        </clipPath>
    </defs>
</svg>